/**
 * Custom hook to return catalog items array of objects with gighest version objects only
 * Prashant Bhatt <pbhatt@svb.com> (svb.com)
 * By default uses usestore if "arrayOfObject" parameter/props not present
 * Returns filtered array of api objects with latest versions only
 *
 */

import { useStore } from '../../core/useStore';
import { sortWithAPIWeight, getCustomSortedApis } from '../utilityFunctions';

export default function useFilteredCatalogLatestVersion(arrayOfObject) {
  const catalogItems = arrayOfObject || useStore.getState().catalogItems; //get catalog items from usestore
  const weightedApisJson = useStore.getState().customApiWeightJson;
  const highestVersionItems = {};
  //get highest version of each item?.name or api name and create an array to hold the version
  catalogItems?.forEach((item) => {
    if (!highestVersionItems[item?.name] || highestVersionItems[item?.name] < item?.version) {
      highestVersionItems[item?.name] = item?.version;
    }
  });
  //filter only object with highest version
  const filteredItemsWithLatestVersion = catalogItems.filter(
    (item) => item?.version === highestVersionItems[item?.name],
  );
  if (
    process.env.REACT_APP_API_ORDER &&
    process.env.REACT_APP_API_ORDER === 'true' &&
    weightedApisJson &&
    weightedApisJson.length > 0
  ) {
    //custom api order from json file in content svc
    return getCustomSortedApis(filteredItemsWithLatestVersion, weightedApisJson);
  } else {
    //custom api order using browse response
    return sortWithAPIWeight(filteredItemsWithLatestVersion);
  }
}
